import { render, staticRenderFns } from "./catalog_tabs.vue?vue&type=template&id=683bd5a6"
import script from "./catalog_tabs.vue?vue&type=script&lang=js"
export * from "./catalog_tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports